import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import cookie from 'react-cookie';

import ReactSlider from 'react-slider';

import ModalCalendar from '../components/ModalCalendar.js';

import {DateRangePickerToggle, DateRangePickerSelectDates} from '../components/DateRangePickerModular';


class OffersHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            calendarEnabled: false,
            filtersEnabled: false,
            dateRangePickerEnabled: false,
            positionsEnabled: false,
            locationsEnabled: false,
            filtersLoaded: false,
            handleClick: this._handleClick.bind(this),
            query: '',
            positions: [],
            priceRange: {
                min: 0,
                max: null
            },
            dateRange: {
                start: moment(),
                end: null
            }
        };

        this.temp = {
            dateRange: {
                start: moment(),
                end: null
            },
            priceRange: {
                min: null,
                max: null
            }
        }
    }

    _handleClick(e) {
        for (let element = e.target; element; element = element.parentNode) {
          if (element.id === 'clickable') {
            return;
          }
        }
        this.setState({
            calendarEnabled: false,
            dateRangePickerEnabled: false,
            positionsEnabled: false,
            locationsEnabled: false
        });
    }

    componentDidMount() {
        window.addEventListener('click', this.state.handleClick);
        this.loadFiltersFromCookie();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.toggleFilters !== this.props.toggleFilters) {
            this.toggleFilters();
        }
        if (nextProps.reloadShifts && !this.props.reloadShifts) {
            this.loadFiltersFromCookie();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.state.handleClick);
    }

    loadFiltersFromCookie() {
        const filters = cookie.load('filters') || null;
        const candidate = this.props.candidate;
        const max_rate = this.props.max_rate;
        const candidate_hourly_rates = candidate.professions.map(profession => {
            return parseFloat(profession.min_hourly_rate);
        });
        const candidate_min_rate = Math.min(...candidate_hourly_rates);
        const min_rate = candidate_min_rate && candidate_min_rate < max_rate ? candidate_min_rate : 0;
        this.temp.priceRange.min = parseInt(min_rate);
        this.temp.priceRange.max = max_rate;
        this.setState({priceRange: {min: parseInt(min_rate), max: max_rate}});
        let positions = _.pluck(this.props.professions, 'position.id');
        if (filters) {
            filters.slice(1).split('&').forEach(value => {
                const curValue = value.split('=');
                if (curValue[0] == 'rate_0') {
                    const minValue = Math.ceil(parseFloat(curValue[1]));
                    this.temp.priceRange.min = minValue < max_rate ? minValue : 0;
                    this.setState({priceRange: {min: minValue, max: this.temp.priceRange.max}});
                }
                if (curValue[0] == 'rate_1') {
                    const maxValue = Math.ceil(parseFloat(curValue[1]));
                    this.temp.priceRange.max = maxValue;
                    this.setState({priceRange: {min: this.temp.priceRange.min, max: maxValue}});
                }
                if (curValue[0] == 'start_time') {
                    this.temp.dateRange.start = curValue[1];
                    this.setState({priceRange: {start: curValue[1], end: this.state.dateRange.end}});
                }
                if (curValue[0] == 'end_time') {
                    this.temp.dateRange.end = curValue[1];
                    this.setState({priceRange: {start: this.state.dateRange.start, end: curValue[1]}});
                }
                if (curValue[0] == 'position') {
                    positions = curValue[1].split(',').map((x) => {return parseInt(x)});
                }
            });
        }
        this.setState({positions});
        this.setFilters();
        this.props.resetReloadShifts();
    }

    slideValueChange(handleValues) {
        this.temp.priceRange = {
            min: handleValues[0],
            max: handleValues[1]
        };

        this.setState({
            priceRange: {
                min: handleValues[0],
                max: handleValues[1]
            },
            calendarEnabled: false,
            dateRangePickerEnabled: false,
            positionsEnabled: false,
            locationsEnabled: false
        });

        this.setFilters();
    }

    toggleFilters() {

        if (this.state.filtersEnabled === true) {
            this.setState({filtersEnabled: false, dateRangePickerEnabled: false});
        } else {
            this.setState({filtersEnabled: true, calendarEnabled: false});
        }
    }

    toggleCalendar() {
        this.setState({
            calendarEnabled: !this.state.calendarEnabled,
            dateRangePickerEnabled: false,
            positionsEnabled: false,
            locationsEnabled: false,
            filtersEnabled: false
        });
    }

    toggleDateRangePicker() {
        this.setState({
            dateRangePickerEnabled: !this.state.dateRangePickerEnabled,
            calendarEnabled: false,
            positionsEnabled: false,
            locationsEnabled: false
        });
    }

    togglePositions() {
        this.setState({
            positionsEnabled: !this.state.positionsEnabled,
            calendarEnabled: false,
            dateRangePickerEnabled: false,
            locationsEnabled: false
        });
    }

    toggleLocations() {
        this.setState({
            locationsEnabled: true,
            calendarEnabled: false,
            dateRangePickerEnabled: false,
            positionsEnabled: false

        });
    }

    getDateFromDateRange (startDate, endDate) {
        this.setState({
            dateRange: {
                start: moment(startDate),
                end: endDate ? moment(endDate) : null
            }
        });

        this.temp.dateRange = {
            start: moment(startDate),
            end: endDate ? moment(endDate) : null
        };

        this.setFilters();
    }

    setFilters(input) {
        let filters = {
            positions: [],
            zip: null,
            city: null,
            street: null,
            dateRange: {
                start: null,
                end: null
            },
            priceRange: {
                min: 0,
                max: 0
            }
        };

        const positions = document.getElementsByName('positions[]');
        const query = this.state.query;

        if (query.length == 0) {
            filters.street = null;
            filters.zip = null;
            filters.city = null;
        }

        for (let i=0; i<positions.length;i++) {
            const position = positions[i];

            if (position.checked === true) {
                filters.positions.push(position.value);
            }
        }

        if (input) {
            this.setState({locationsEnabled: false});
            if (input.city) {
                filters.street = null;
                filters.zip = null;
                filters.city = input.city;
                this.refs.searchInput.getDOMNode().value = input.city.length > 25 ? input.city.substring(0, 25) + '...' : input.city;
            } else if (input.street) {
                filters.street = input.street;
                filters.city = null;
                filters.zip = null;
                this.refs.searchInput.getDOMNode().value = input.street.length > 25 ? input.street.substring(0, 25) + '...' : input.street;
            } else if (input.zip) {
                filters.zip = input.zip;
                filters.street = null;
                filters.city = null;
                this.refs.searchInput.getDOMNode().value = input.zip.length > 25 ? input.zip.substring(0, 25) + '...' : input.zip;
            }
        }

        filters.dateRange.start = this.temp.dateRange.start;
        filters.dateRange.end = this.temp.dateRange.end;

        filters.priceRange.min = this.temp.priceRange.min;
        filters.priceRange.max = this.temp.priceRange.max;
        this.getFilteredShifts(filters);
    }

    getFilteredShifts(filters) {
        let query = '?rate_0=' + filters.priceRange.min + '&rate_1=' + filters.priceRange.max + '&';
        if (filters.positions.length) {
            query += 'position=' + filters.positions.join(',') + '&';
        }
        if (filters.zip) {
            query += 'zip=' + filters.zip + '&';
        }
        if (filters.city) {
            query += 'city=' + filters.city + '&';
        }
        if (filters.street) {
            query += 'street=' + filters.street + '&';
        }
        query += filters.dateRange.start ? `start_time=${moment(filters.dateRange.start).format("YYYY-MM-DD")}&` : `start_time=${moment().format("YYYY-MM-DD")}&`;
        query += filters.dateRange.end ? `end_time=${moment(filters.dateRange.end).format("YYYY-MM-DD")}` : '';

        cookie.save('filters', query);
        this.props.filterShifts(query);
    }

    selectPosition(id) {
        let positions = this.state.positions;

        // When there's no positions it means that all of them are selected
        if (positions.length == 0) {
            positions = _.pluck(this.props.professions, 'position.id');
        }

        const index = positions.indexOf(id);
        if (index > -1) {
            positions.splice(index, 1);
        } else {
            positions.push(id);
        }
        this.setState({positions});
        this.setFilters();

    }

    getPositionOptions(professions) {
        let results = [];
        const selected = this.state.positions;
        professions.forEach(profession => {
            const checked = selected.length == 0 || selected.indexOf(profession.position.id) > -1;
            results.push(
                <label id="clickable" key={profession.position.id} className="checkbox-wrapper">
                    <input type="checkbox" checked={checked} name="positions[]" value={profession.position.id} onChange={_.debounce(this.selectPosition.bind(this, profession.position.id), 500)}/>
                    <div className="green-ball"></div>
                    <div className="fake-checkbox">{profession.position.name}</div>
                </label>
            );
        });
        return results
    }

    boldSearchText(input) {
        const query = this.state.query;

        if (query.length) {
            const index = input.indexOf(query);
            return (
                index == 0 ?
                '<span class="search-key"><strong>' + input.substring(index, query.length) + '</strong>' + input.substring(query.length) + '</span>' :
                '<span class="search-key">' + input.substring(0, index) + '<strong>' + input.substring(index, index + query.length) + '</strong>' + input.substring(index + query.length) + '</span>'
            );
        }
    }

    getLocationOptions(searchResults) {
        const query = this.state.query;
        if(Object.keys(searchResults).length && query.length >= 2) {
            let results = [];
            if (searchResults.zip.length + searchResults.city.length + searchResults.street.length === 0 && this.state.query.length) {
                results.push(
                    <label id="clickable" className="checkbox-wrapper">
                        <div className="fake-checkbox">Search returned 0 results.</div>
                    </label>
                );
            }
            if (searchResults.zip.length) {
                searchResults.zip.forEach(zip => {
                    const zipName = this.boldSearchText(zip[0]) + ' ' + zip[1] + ', ' + zip[2];
                    results.push(
                        <label id="clickable" key={zip[0]} className="checkbox-wrapper" onClick={this.setFilters.bind(this, {'zip': zip[0]})}>
                            <div className="fake-checkbox" dangerouslySetInnerHTML={{__html: zipName}}></div>
                        </label>
                    );
                });
            }
            if (results.length < 5 && searchResults.city.length) {
                searchResults.city.forEach(city => {
                    const cityName = this.boldSearchText(city[0]) + ', ' + city[1];
                    results.push(
                        <label id="clickable" key={city[0]} className="checkbox-wrapper" onClick={this.setFilters.bind(this, {'city': city[0]})}>
                            <div className="fake-checkbox" dangerouslySetInnerHTML={{__html: cityName}}></div>
                        </label>
                    );
                });

            }
            if (results.length < 5 && searchResults.street.length) {
                searchResults.street.forEach(street => {
                    const streetName = this.boldSearchText(street[0])+ ' ' + street[1] + ', ' + street[2];
                    results.push(
                        <label id="clickable" key={street[0]} className="checkbox-wrapper" onClick={this.setFilters.bind(this, {'street': street[0]})}>
                            <div className="fake-checkbox" dangerouslySetInnerHTML={{__html: streetName}}></div>
                        </label>
                    );
                });

            }

            return results;
        }
    }

    getDatePickerText() {
        const start_time = this.temp.dateRange.start;
        const end_time = this.temp.dateRange.end;
        let result = moment().format('ddd D.MMM') + ' - ...';
        if (start_time) {
            if (end_time) {
                result = moment(start_time).format('ddd D.MMM') + ' - ' + moment(end_time).format('ddd D.MMM');
            } else {
                result = moment(start_time).format('ddd D.MMM') + ' - ...';
            }
        }
        return result;
    }

    searchLocations(e) {
        const query = e.target.value;
        this.setState({query});
        if (query.length >= 2) {
            let pos_res = [];
            const positions = document.getElementsByName('positions[]');
            const start_time = moment(this.temp.dateRange.start).startOf('day').format('YYYY-MM-DD HH:mm');
            let end_time = null;
            if (this.temp.dateRange.end) {
                end_time = moment(this.temp.dateRange.end).startOf('day').format('YYYY-MM-DD HH:mm');
            }
            for (let i=0; i<positions.length;i++) {
                const position = positions[i];

                if (position.checked === true) {
                    pos_res.push(position.value);
                }
            }
            _.debounce(this.props.filterLocations.bind(null, query, pos_res, start_time, end_time), 500)();
        } else {
            this.setFilters();
        }

    }

    render() {
        const professions = this.props.professions;
        const dateText = this.getDatePickerText();
        const max_rate = this.props.max_rate;
        const searchResults = this.props.searchResults;
        const count = this.props.count;
        const dates = this.props.dates;
        let filterClasses = (this.state.filtersEnabled ? ' filter-container' : 'filter-container closed');

        let calendarClasses = (this.state.calendarEnabled ? ' calendar-wrapper' : 'calendar-wrapper disabled');

        if (this.temp.priceRange.min === null || this.temp.priceRange.max === null) {
            return (<div></div>);
        }

        let filterPrices = {
            min: this.temp.priceRange.min || 0,
            max: this.temp.priceRange.max || max_rate
        };

        return (
            <header className="offers-header">
                <div className="maxwidth-wrapper">
                    <div className="left">
                        <h1 className="page-title">Offers</h1>
                        <div className="offer-count">{count}</div>
                        <div className="daterange">{dateText}</div>
                    </div>

                    <div className="right">
                        <div className="edit-filters" ref="editFilters" onClick={this.toggleFilters.bind(this)}>Edit filters</div>
                        <div className="edit-schedule" id="clickable" onClick={this.toggleCalendar.bind(this)}>Edit schedule</div>
                    </div>

                </div>

                <div id="clickable" className={calendarClasses}>
                    <ModalCalendar onChange={this.props.calendarOnChange} dates={dates} />
                </div>

                <div className={filterClasses}>
                    <div className="filter-wrapper whitebox">
                        <div className="inputs clearfix">
                            <div className="input input-positions fake-checkbox">
                                <h4>Positions</h4>

                                <div  id="clickable" className={'Select ' + (this.state.positionsEnabled ? 'opened' : '')}>
                                    <div className="Select-control" onClick={this.togglePositions.bind(this)}>
                                        <div className="Select-placeholder">Filter by positions</div>
                                    </div>

                                    <div className="dropdown-checkbox">
                                        {this.getPositionOptions(professions)}
                                    </div>
                                </div>
                            </div>

                            <div className="input input-locations fake-checkbox">
                                <h4>Locations</h4>

                                <div id="clickable" className={'Select ' + (this.state.locationsEnabled ? 'opened' : '')}>
                                    <span className="search-icon" onClick={this.toggleLocations.bind(this)}>
                                        <input onChange={this.searchLocations.bind(this)} ref="searchInput" className="search-input" type="text" placeholder="Search locations" />
                                    </span>

                                    <div className="dropdown-checkbox">
                                        {this.getLocationOptions(searchResults)}
                                        {/*<label className="checkbox-wrapper change-filtering-method">
                                            <div className="fake-checkbox">Filter by mile radius instead?</div>
                                        </label>*/}
                                    </div>
                                </div>
                            </div>

                            <div className="input date-range">
                                <h4 className="has-info">Date range</h4>

                                <div id="clickable" className="Select" onClick={this.toggleDateRangePicker.bind(this)}>
                                    <div className="Select-control">
                                        <div className="time-period" >
                                            <DateRangePickerToggle dateText={dateText}/>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="datepicker-container">
                                <DateRangePickerSelectDates id="clickable" dates={this.state.dateRange} enabled={this.state.dateRangePickerEnabled} dateCallback={this.getDateFromDateRange.bind(this)} />
                            </div>
                        </div>

                        <h4 className="wagerangeheader">Wage range</h4>
                        <div className="slider-wrapper">
                            <ReactSlider barClassName={'orange'} minDistance={1} defaultValue={[filterPrices.min, filterPrices.max]} min={0} max={max_rate} pearling={true} withBars={true} onChange={_.debounce(this.slideValueChange.bind(this), 500)} />

                            <div className="ranges" >{DJ_CONST.LOCALE_CONF.currency}{filterPrices.min} - {DJ_CONST.LOCALE_CONF.currency}{filterPrices.max}</div>
                        </div>

                    </div>
                </div>

            </header>
        );
    }
}

export default OffersHeader;



/** WEBPACK FOOTER **
 ** ./app/src/components/OffersHeader.js
 **/